import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { withTheme } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import "./Breadcrumb.css";

/**
 * Componente que genera links con la pagina actual y su jerarquia. Tiene predefinido clases CSS, pero es necesario extenderlas para definir colores y background.
 */
class Breadcrumb extends PureComponent {
	constructor(props) {
		super(props);
		this.generateBreadcrumb = this.generateBreadcrumb.bind(this);
	}

	generateBreadcrumb() {
		const { path, routesInfo, separator, theme } = this.props;
		const pathWithSlash =
			path[path.length - 1] !== "/" ? path.concat("/") : path;
		let pathArray = pathWithSlash.split("");
		let slashLocation;
		let screen;
		let key = 1;
		pathArray.shift();
		let breadcrumb = [
			<li key={key}>
				<NavLink
					to={routesInfo.home.path}
					className={["breadcrumb-link", this.props.linkClass].join(" ")}
					style={theme.breadcrumb.text}
				>
					{routesInfo.home.name}
				</NavLink>
			</li>
		];
		while (pathArray.length > 0) {
			slashLocation = pathArray.indexOf("/");
			screen = pathArray.slice(0, slashLocation).join("");
			if (routesInfo[screen]) {
				key++;
				breadcrumb.push(
					<li key={key}>
						{pathArray.length > 0 ? (
							<span style={theme.breadcrumb.separator}> {separator}</span>
						) : null}
						<NavLink
							to={routesInfo[screen].path}
							className={["breadcrumb-link", this.props.linkClass].join(" ")}
							style={theme.breadcrumb.text}
						>
							{routesInfo[screen].name}
						</NavLink>
					</li>
				);
			}
			pathArray.splice(0, slashLocation + 1);
		}
		return (
			<ul className={["bc-ul-style", this.props.ulContainerClass].join(" ")}>
				{breadcrumb}
			</ul>
		);
	}

	render() {
		const {theme} = this.props
		return (
			<div
				style={theme.breadcrumb.container}
				// className={["breadcrumb-container", this.props.mainContainerClass].join(
				// 	" "
				// )}
			>
				{this.generateBreadcrumb()}
			</div>
		);
	}
}

Breadcrumb.propTypes = {
	/**
	 * Ruta actual en el navegador.
	 */
	path: PropTypes.string.isRequired,
	/**
	 * Objeto que tendra la informacion de las rutas.
	 */
	routesInfo: PropTypes.object.isRequired,
	/**
	 * Separador entre los links.
	 */
	separator: PropTypes.string,
	/**
	 * Agrega clase CSS a div contenedor de componente.
	 */
	mainContainerClass: PropTypes.string,
	/**
	 * Agrega clase CSS a elemento ul de HTML.
	 */
	ulContainerClass: PropTypes.string,
	/**
	 * Agrega InlineStyle a separador de links. Tomar principalmente para cambiar dicho color.
	 */
	separatorStyle: PropTypes.object
};

Breadcrumb.defaultProps = { separator: ">" };

export default withTheme(Breadcrumb);



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js